module.exports = __webpack_public_path__ + "img/background033.jpg";